<template>

  <div>

          <div class="section-title text-center">
            <h1 class='display-1 text-uppercase font-weight-medium text-xs-center'> Ready To Engage?</h1>
            <h3 class='header font-weight-medium text-xs-center'>We look forward to working with you!</h3>
          </div>
          <v-row class="fill-height ma-3"
                 align="top"
                 justify="center">
            <v-col xs=12 md=4>

              <v-form

                submit>
                <v-flex xs12 md12>
                  <v-text-field maxlength='50'
                                label="Your Name"
                                v-model="name"
                                id='name'
                                required></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field maxlength='90'
                                label="Company"
                                v-model="company"
                                id='company'
                                required></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field maxlength="50"
                                label="Phone Number"
                                v-model="phone"
                                id='phone'
                                required></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field maxlength="90"
                                label="E-Mail"
                                v-model="email"
                                id='email'
                                required></v-text-field>
                </v-flex>
                <v-flex xs12 md12 mt-3>
                  <v-textarea label="Message"
                              v-model="bodytext"
                              counter
                              maxlength='500'
                              id='bodytext'
                              auto-grow></v-textarea>
                  <center>
                    <!-- <div class="g-recaptcha" data-sitekey="6LeavKsUAAAAALsJqLc6FvrFpoUkGSsdi7zYLDgx"></div> -->
                    <v-btn tile color="primary" @click='emailSubmit'>Submit</v-btn>
                  </center>

                </v-flex>
              </v-form>
            </v-col>

              <v-col cols=2 class='subtitle-2 hidden-sm-and-down'>
                <div class='headline'>Houston Digital</div>
                <div>
                  Houston Digital has been in the lean software development industry since 1990. Bringing innovative ways to keep track of
                  complex daily business functions. Headquartered in Idaho we are less than 20 miles away from great snow skiing, water
                  sports and class 4 whitewater rafting an much more for the avid outdoorsman.
                </div>
                  <br/>
                <p>
                  Houston Digital Corp.<br/> 943 W Overland Rd. Suite 144<br/> Meridian, ID 83642<br/>
                </p>
                <A HREF='tel:2089471738'>208 947 1738</a> Phone<br/> 208 402 4779 (FAX)<br/>
                <a href='mailto:sales@summitcrs.com'>sales@summitcrs.com</a><br/>


            </v-col>

          </v-row>

    <v-footer padless>
      <v-layout>
        <v-flex xs12>
          <v-card flat tile class="grey darken-3 white--text text-center">
            <v-card-text>
              <v-btn v-for="(footer, index) in footer"
                     :key="index"
                     :href='footer.src'
                     class="mx-3 white--text"
                     icon>
                <v-icon size="24px">{{ footer.icon }}</v-icon>
              </v-btn>
            </v-card-text>
            <v-card-text class="white--text">
              &copy; Houston Digital Corp. {{ new Date().getFullYear() }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>

</template>
<script>

  const axios = require('axios');
  export default {
    data: () => {
      return {
          footer: [
            {
              icon: 'fab fa-facebook',
              src: 'https://www.facebook.com/Summitcrs/'
            },
            {
              icon: 'fab fa-linkedin',
              src: 'https://www.linkedin.com/company/15163057/'
            },
            {
              icon: 'fab fa-youtube',
              src: 'https://www.youtube.com/channel/UCbbIMPJtE_gyQ9oIzwdVN4Q'
            }
          ]
        }

      },
      methods: {
        emailSubmit(){

          let api = axios.create({
            baseURL: 'https://engagesms.net/php/emailengage.php',
            method: 'post',
            headers: {
              'Access-Control-Allow-Origin':'*',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Methods': 'Post',
              'X-Requested-With': 'XMLHttpRequest'

            },
            timeout: 100000
          });

          let contact = {
            name: this.name,
            company: this.company,
            phone: this.phone,
            email: this.email,
            bodytext: this.bodytext
          }

          api.post('', contact)
            .then(response => {
              console.log('success', response.data.message)
            }).catch(error => {
              console.log(error)
            }).finally(
              alert('Message Submited, please allow for 24-48 hours for response. If you require immediate assistance sooner please call us at 208-947-1738.'),
              location.reload(),
            );
        }

        }
      }
</script>
